import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { PlaylistVideo } from '@/store/playlist/types';
import { Play, Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PrimeVideoCardProps {
  video: PlaylistVideo;
  index: number;
  accentColor: string;
  onClick: () => void;
}

export function PrimeVideoCard({ video, index, accentColor, onClick }: PrimeVideoCardProps) {
  useLanguage();
  // Mock duration (3-15min)
  const mockDuration = `${Math.floor(Math.random() * 12 + 3)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`;

  return (
    <div
      onClick={onClick}
      className={cn(
        'group cursor-pointer transition-all duration-200',
        'hover:scale-[1.03]'
      )}
      style={{
        ['--accent-color' as string]: accentColor,
      }}
    >
      {/* Thumbnail 16:9 */}
      <div className="relative aspect-video bg-[#141414] rounded-lg overflow-hidden">
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        
        {/* Play Icon on Hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <div 
            className="w-14 h-14 rounded-full flex items-center justify-center"
            style={{ backgroundColor: accentColor }}
          >
            <Play className="w-7 h-7 text-white fill-white" />
          </div>
        </div>

        {/* Mock placeholder (can be replaced with actual thumbnail) */}
        <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900" />

        {/* Duration Badge */}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-black/75 px-2 py-1 rounded text-xs text-white font-medium">
          <Clock className="w-3 h-3" />
          {mockDuration}
        </div>

        {/* Hover Border Effect */}
        <div 
          className="absolute inset-0 border-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none"
          style={{ borderColor: accentColor }}
        />
      </div>

      {/* Title */}
      <div className="mt-3 px-1">
        <h3 className="text-white text-sm font-semibold line-clamp-2 leading-snug">
          {video.episodeTitle || translateInterfaceText("Aula {value0}", { value0: (index + 1) })}
        </h3>
      </div>
    </div>
  );
}
